import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PeremrillojiParametri, PeremriNumri, PeremriVeta, PeremriRasa, PeremriTrajta } from '@core/enums/peremri/peremri.enum';
import { PeremriConstants } from '@core/globals/peremri/peremri-constants';
import { PeremriForCreationDTO } from '@core/interfaces/dto/peremri-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { PeremriIPacaktuarFormulaService } from './peremri-i-pacaktuar-formula.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriIPacaktuarService {

  constructor(
    private fb: UntypedFormBuilder,
    private peremriIPacaktuarFormulaService: PeremriIPacaktuarFormulaService,
  ) { }

  insertForms(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {
    const formArray = form.get('peremriBaza.peremriIPacaktuar') as UntypedFormArray;
    this.generateIPacaktuarForms(formArray, manual);
    peremriBaza.peremri?.forEach((item) => {
      let index = formArray.controls.findIndex(
        (c) =>
          c.get('trajtaId')?.value == item.trajtaId &&
          c.get('vetaId')?.value == item.vetaId &&
          c.get('rasaId')?.value == item.rasaId &&
          c.get('pershkrimi')?.value == ''
      );
      if (index != -1) {
        formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
      } else {
        this.addNewLakimi(form, item.numriId, item.trajtaId, item.rasaId, item.pershkrimi);
      }
    });
  }

  generateForms(form: UntypedFormGroup, manual: boolean) {
    this.generateIPacaktuarForms(form.get('peremriBaza.peremriIPacaktuar') as UntypedFormArray, manual);
  }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    let formArray = form.get('peremriBaza.peremriIPacaktuar') as UntypedFormArray;
    this.peremriIPacaktuarFormulaService.generateFormula(peremriLlojiParametri, formArray);
  }

  generateIPacaktuarForms(formArray: UntypedFormArray, manual: boolean) {

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    for (const pn of PeremriConstants.PeremriNumri) {
      for (const pt of PeremriConstants.PeremriTrajta) {
        for (const pr of PeremriConstants.PeremriRasat) {
          const peremriForm = this.fb.group({
            numriId: pn.id,
            trajtaId: pt.id,
            rasaId: pr.id,
            pershkrimi: '',
          });

          formArray.push(peremriForm);
        }
      }
    }

    for (const pr of PeremriConstants.PeremriRasat) {
      const peremriForm = this.fb.group({
        numriId: null,
        trajtaId: null,
        rasaId: pr.id,
        pershkrimi: '',
      });

      formArray.push(peremriForm);
    }


    if (!manual) formArray.disable();
  }

  addNewLakimi(form: UntypedFormGroup, numri: PeremriNumri | null, trajta: PeremriTrajta | null, rasa: PeremriRasa | null, pershkrimi?: string) {
    const formArray = <UntypedFormArray>form.get('peremriBaza.peremriIPacaktuar');
    const peremriForm = this.fb.group({
      numriId: numri,
      trajtaId: trajta,
      rasaId: rasa,
      pershkrimi: pershkrimi
    });
    formArray.push(peremriForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: PeremriForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('peremriBaza.peremriIPacaktuar') as UntypedFormArray;

    formArray.value.forEach((p: any) => {
      creationDTO.push({
        numriId: p.numriId,
        trajtaId: p.trajtaId,
        rasaId: p.rasaId,
        pershkrimi: p.pershkrimi
      })
    })
    return creationDTO;
  }
}
